
import DefinedConstant from '../data/DefinedConstant'
import DefinedFunction from '../data/DefinedFunction'

export let util = {
    _aLogicFn: ['and', 'or'],
    _aFunction: Object.keys(DefinedFunction),
    _aMembers: DefinedConstant,
    _calcFn: DefinedFunction,

    REGEX: {
        member: /^([^,:;'=\[\]]+)$/,
        // memberWithBracket: /^\${[^,:;'=\[\]]+}/,
        endWithIf: /.*if$/i
    },
    /**
     * [aaa] --> aaa
     * 
     * @param {String} sMember
     */
    removeMemberBrackets: function (sMember) {
        if (sMember.indexOf('[') !== -1 && sMember.indexOf(']') !== -1) {
            sMember = sMember.trim();
            if (sMember[0] === "[") {
                sMember = sMember.substring(1);
            }
            if (sMember[sMember.length - 1] === "]") {
                sMember = sMember.substring(0, sMember.length - 1);
            }
        }
        return sMember;
    },

    TreeFilter(tree, ids, parent) {
        let _tree = JSON.parse(JSON.stringify(tree))
        if (ids.length == 0) {
            return _tree
        }
        let selectedNodes = []
        let nodes = _tree.filter((item, index) => {
            if (!item.children || item.children.length == 0) {
                item.checked = false
                item.selected = false
                if (ids.indexOf(item.name) > -1) {
                    if (parent) parent.expand = true
                    if (ids.length > 1) {
                        item.checked = true
                    } else {
                        item.selected = true
                    }
                    selectedNodes.push(item)
                }
                return true
            } else if (item.children && item.children.length > 0) {
                let _ret = this.TreeFilter(item.children, ids, item)
                item.children = _ret.nodes
                selectedNodes = selectedNodes.concat(_ret.selectedNodes)
                let ret = item.children.length > 0
                if (ret && parent) parent.expand = true
                return ret
            } else {
                return false
            }
        })
        return { 'nodes': nodes, 'selectedNodes': selectedNodes }
    }
}
